// extracted by mini-css-extract-plugin
export default {"body":"ihTpcU","buttons":"rZsjz7","button":"KZ_HSE","conversion":"TVRLHB","socialButton":"neoPOA"};